// ═══ 말소 셸 라우트 — Dashboard 가 /main/* 에 마운트되므로 여기 path 는 'main' 기준 상대 (B3 리뷰 §2.1) ═══
// 라우트 7개(홈 분리 Jin 10/27) + 전체 화면 정산 주소(/main/cancel-ledger → 정산 탭) + catch-all. 그 외 /main/* 경로(대시보드·차량관리·검차 셸 /s/* 포함)는 /main/m/home 으로 되돌린다 —
// 검차 셸과 달리 isManagePath 예외가 없다(말소 셸엔 차량관리 화면이 없음).
import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useIsDesktop } from '../simple/useDesktop';
import MalsoHome from './screens/MalsoHome';
import MalsoList from './screens/MalsoList';
import MalsoDetail from './screens/MalsoDetail';
import MalsoRequest from './screens/MalsoRequest';
import MalsoMore from './screens/MalsoMore';
import MalsoGuide from './screens/MalsoGuide';
import MalsoLedger from './screens/MalsoLedger';
import MalsoClients from './screens/MalsoClients';

export var MALSO_HOME = '/main/m/home';
export var MALSO_LIST = '/main/m/malso';

// 탭 — 셸 상단(데스크톱, more 제외) / 하단(모바일) 공용. BottomTabs 열 수 = items.length.
// 순서 홈 · 말소 · 정산(B4 W2) · 더보기 (검차 셸과 같은 구성, 홈 분리 Jin 10/27) — 데스크톱 상단은 홈 · 말소 · 정산.
export var MALSO_TABS = [
  { id: 'home', to: MALSO_HOME, labelKey: 'shellTabHome' },
  { id: 'malso', to: MALSO_LIST, labelKey: 'malsoModeTabMalso' },
  { id: 'ledger', to: '/main/m/ledger', labelKey: 'malsoModeTabLedger' },
  { id: 'more', to: '/main/m/more', labelKey: 'shellTabMore' }
];

/// 현재 경로 → 활성 탭 id. 홈은 home, 정산은 ledger, 더보기·이용 안내는 more, 그 외(말소 탭·상세·신청)는 malso.
export function tabIdOf(pathname) {
  var p = String(pathname || '');
  if (p.indexOf(MALSO_HOME) === 0) return 'home';
  if (p.indexOf('/main/m/ledger') === 0) return 'ledger';
  if (p.indexOf('/main/m/more') === 0 || p.indexOf('/main/m/guide') === 0 || p.indexOf('/main/m/clients') === 0) return 'more';
  return 'malso';
}

// 데스크톱(≥1024) 의 /m/malso/:id 는 2-pane 말소 탭이 그대로 산다(MalsoList 가 useParams().id 로 우측 상세를 그린다).
// ≤1023 은 상세 페이지. 두 경로가 같은 element 타입이어야 행 클릭 시 remount(칩 선택·목록 재조회)가 없다.
function ListOrDetail(props) {
  var isDesktop = useIsDesktop();
  var id = useParams().id;
  return (isDesktop || !id) ? <MalsoList {...props} /> : <MalsoDetail {...props} />;
}

function MalsoRoutes(props) {
  var p = { user: props.user, showToast: props.showToast };
  return (<Routes>
    <Route path="m" element={<Navigate to={MALSO_HOME} replace />} />
    <Route path="m/home" element={<MalsoHome {...p} />} />
    <Route path="m/malso" element={<ListOrDetail {...p} />} />
    <Route path="m/malso/:id" element={<ListOrDetail {...p} />} />
    <Route path="m/request" element={<MalsoRequest {...p} />} />
    <Route path="m/ledger" element={<MalsoLedger {...p} />} />
    <Route path="m/guide" element={<MalsoGuide />} />
    <Route path="m/more" element={<MalsoMore {...p} onLogout={props.onLogout} />} />
    <Route path="m/clients" element={<MalsoClients {...p} />} />
    <Route path="cancel-ledger" element={<Navigate to="/main/m/ledger" replace />} />
    <Route path="*" element={<Navigate to={MALSO_HOME} replace />} />
  </Routes>);
}

export default MalsoRoutes;
